import React, { useState, useEffect } from "react";
import { useParams,Link,useNavigate } from 'react-router-dom';
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import InputText from "../../components/includes/InputText";
import DaumPostCode from "../../../components/popups/DaumPostCode";
import {ChangeMobileNumber,SetBasePageStatus,isNull} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

export const BranchDetail = () => {
  let { editMode,bh_idx } = useParams();
  const navigate = useNavigate();

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  const [varBranchInfo,setBranchInfo] = useState({});
  //선택 정보 값 배열
  const [varBusinessList,setBusinessList] = useState([]);
  const [varRoyaltyMList,setRoyaltyMList] = useState([]);
  const [varRoyaltyFList,setRoyaltyFList] = useState([]);

  //센터 정보 호출
  const GetBranchInformation = async() => {
    const sendData = {bh_idx:bh_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_branch_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0){
          const branchInfo = datas.results[0];
          branchInfo.bh_npwd = "";
          setBranchInfo(branchInfo);
        } 
        setBusinessList(datas.business);
        setRoyaltyMList(datas.royalty_m);
        setRoyaltyFList(datas.royalty_f);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'BRANCH',item:'Branches'});
    console.log(varAdminMenus);
    const newItem = {bh_idx:0,bh_code:'',bh_company:'',bh_ecompany:'',bh_status:-1,m_ry_idx:0,f_ry_idx:0,bh_name:'',bh_id:'',
        bh_biz_idx:0,bh_biz_code:'',bh_mobile:'',bh_email:'',bh_zipcode:'',bh_addr1:'',bh_addr2:'',br_idx:0,bh_pwd:'',bh_npwd:'',
        bh_m_classroom:6,bh_f_classroom:6,bh_member_id:'',bh_merchant_id:'',mcount:0,fcount:0};
    setBranchInfo(newItem);              

    GetBranchInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보변경
  const onChangeBranchInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "bh_mobile") {
      setBranchInfo({...varBranchInfo,[name]:ChangeMobileNumber(value)});
    } else  if(name === "m_ry_idx" || name === "f_ry_idx") {
      const ry_idx = Number(value);
      setBranchInfo({...varBranchInfo,[name]:ry_idx});
    } else {
      setBranchInfo({...varBranchInfo,[name]:value});
    }
  }
  
  //삭제  & 초기화
  const onModifyBranchHandler = async(e,imode) => {
    //선택된 센터 고유번호를 문자열로 생성
    let sprompt = `센터를 삭제하시겠습니까?`;
    if(imode === 3) sprompt = `센터의 비밀번호를 초기화하시겠습니까?`;
    if(!window.confirm(sprompt)) return false;

    const sendData = {mode:imode,bh_idx:bh_idx,bh_biz_code:varBranchInfo.bh_biz_code};
    await axios.post(`${process.env.REACT_APP_HOST}/_modify_branch_list`, sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      if(datas.retvalue === 1) {
        navigate('/Admin/BranchList');
      } else {
        alert(res.data.message);
      }
    });
  }

  //우편번호/주소찾기
  const [varOpenZipcode, setOpenZipcode] = useState(false);
  //우편번호/주소 검색 팝업창 열기/닫기
  const onOpenZipcodeHandler = (e, bts) => {
    e.preventDefault();
    SetBasePageStatus(bts);
    setOpenZipcode(bts);
  };
  //우편번호/주소 검색팝업창 닫기
  const ClosePopupZipcode = () => {
    SetBasePageStatus(false);
    setOpenZipcode(false);
  };
  const ChangeAddress = (zipcode,fullAddr,roadAddr,locString) => {
    console.log(zipcode,fullAddr,roadAddr,locString);
    setBranchInfo((prevState)=>{return{...prevState, bh_zipcode:zipcode, bh_addr1:roadAddr}});
  };

  //저장
  const onUpdateBranchHandler = async(e) => {
    if(isNull(varBranchInfo.bh_code)) {
      alert('센터고유코드를 먼저 입력하세요.'); return false;
    } else if(isNull(varBranchInfo.bh_member_id)) {
        alert('센터 결제 회원 코드를 먼저 입력하세요.'); return false;
    } else if(isNull(varBranchInfo.bh_merchant_id)) {
      alert('센터 결제 거래 코드를 먼저 입력하세요.'); return false;
    } else if(isNull(varBranchInfo.bh_company)) {
      alert('센터명을 먼저 입력하세요.'); return false;
    } else if(varBranchInfo.m_ry_idx === 0) {
      alert('마마몽떼 로열티를 먼저 선택하세요.'); return false;
    } else if(varBranchInfo.f_ry_idx === 0) {
      alert('플라이 로열티를 먼저 선택하세요.'); return false;
    } else if(varBranchInfo.bh_biz_code === "") {
      alert('사업자 등록번호를 먼저 입력하세요.'); return false;
    }
    if(!window.confirm('센터 정보를 저장하시겠습니까?')) return false;

    if(Number(bh_idx)===0 || varBranchInfo.bh_status === -1) {
      const sendData = {branch_member_id:varBranchInfo.bh_member_id,branch_merchant_id:varBranchInfo.bh_merchant_id};
      await axios.post(`${process.env.REACT_APP_HOST}/_check_branch_join`,sendData).then((res) => {
        console.log(res.data);
        const datas = res.data;
        const retcode = datas.results.code;
        if(datas.retvalue === 1 && (retcode === '0000' || retcode === "1500")) {
          let bh_state = 1;
          if(retcode === "1500") bh_state = -1;
          //서버 데이타베이스에 저장
          const directUrl = datas.results.info.url;
          UpdateBranchInformation(bh_state,directUrl);
        } else {  //인증오류
          alert(datas.results.msg);
          UpdateBranchInformation(-1,'');
        }
      });
    } else {
      UpdateBranchInformation(varBranchInfo.bh_status);
    }
  }

  const UpdateBranchInformation = async(bh_state,directUrl) => {
    const sendData = {bh_idx:bh_idx,dataInfo:varBranchInfo,bh_state:bh_state};
    await axios.post(`${process.env.REACT_APP_HOST}/_update_branch_information`, sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      if(datas.retvalue === 1) {
        if(directUrl !== "" && bh_state === -1) {
          window.open(directUrl,'_blank');
        }
        navigate('/Admin/BranchList');
      } else {
        alert(res.data.message);
      }
    });
  }

  //가맹신청
  const onRetryJoinBranchHandler = async(e) => {
    if(isNull(varBranchInfo.bh_member_id)) {
      alert('센터 결제 회원 코드를 먼저 입력하세요.'); return false;
    } else if(isNull(varBranchInfo.bh_merchant_id)) {
      alert('센터 결제 거래 코드를 먼저 입력하세요.'); return false;
    }
    const sendData = {branch_member_id:varBranchInfo.bh_member_id,branch_merchant_id:varBranchInfo.bh_merchant_id};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_branch_join`,sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      const retcode = datas.results.code;
      if(datas.retvalue === 1 && (retcode === '0000' || retcode === "1500")) {
        if(retcode === "1500") {
          //서버 데이타베이스에 저장
          const directUrl = datas.results.info.url;
          if(directUrl !== "") {
            window.open(directUrl,'_blank');
          }
        } else if(datas.results.code === '0000') {
          UpdateBranchStatus();
        }
      } else {  //인증오류
        alert(datas.results.msg);
      }
    });
  }

  //상태변경
  const UpdateBranchStatus = async() => {
    const sendData = {bh_idx:bh_idx,bh_status:1};
    await axios.post(`${process.env.REACT_APP_HOST}/_update_branch_status`, sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      alert(res.data.message);
      if(datas.retvalue === 1) {
        setBranchInfo({...varBranchInfo,bh_status:1});
      }
    });
  }

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'센터 상세'} varDirection={'센터관리'}/>
        <div className="admin-content">
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"></col><col width="30%"></col><col width="20%"></col><col width="30%"></col></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>센터코드</th>
                  <td colSpan={3}><InputText varMode={Number(editMode)} varName={'bh_code'} varArrayInfo={varBranchInfo} onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>센터 결제 회원 코드</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_member_id'} varArrayInfo={varBranchInfo} onChangeHandler={onChangeBranchInfoHandler}/></td>
                  <th>센터 결제 거래 코드</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_merchant_id'} varArrayInfo={varBranchInfo} onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>센터명</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_company'} varArrayInfo={varBranchInfo} onChangeHandler={onChangeBranchInfoHandler}/></td>
                  <th>센터명(영문)</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_ecompany'} varArrayInfo={varBranchInfo} onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>운영</th>
                  <td colSpan={3}>{Number(editMode)===0?
                      varBranchInfo.bh_status===1?"정상운영중":varBranchInfo.bh_status===-1?"가맹신청중":"휴원"
                    :
                      <select name='bh_status' style={{width:"120px"}} value={varBranchInfo.bh_status} onChange={onChangeBranchInfoHandler}>
                        <option value={1}>정상운영중</option>
                        <option value={0}>휴원</option>
                        <option value={-1}>가맹신청중</option>
                      </select>
                    }
                    {varBranchInfo.bh_status===-1?<button style={{width:"90px"}} className="btn line" onClick={e=>onRetryJoinBranchHandler(e)}>가맹신청</button>:null}
                  </td>
                </tr>
                <tr>
                  <th>로얄티 (마마몽떼)</th>
                  <td>
                      <select name="m_ry_idx" style={{width:"120px"}} className={Number(editMode)===0?"adm_hide":""} value={isNull(varBranchInfo.m_ry_idx)?0:varBranchInfo.m_ry_idx} onChange={onChangeBranchInfoHandler}>
                        <option value={0}>선택</option>
                        {varRoyaltyMList.map((mamas,i)=>(
                          <option key={'mamas_'+i} value={mamas.ry_idx}>{mamas.ry_name}</option>
                        ))}
                      </select>
                    </td>
                    <th>로얄티 (플라이)</th>
                    <td>
                      <select name="f_ry_idx" style={{width:"120px"}} className={Number(editMode)===0?"adm_hide":""} value={isNull(varBranchInfo.f_ry_idx)?0:varBranchInfo.f_ry_idx} onChange={onChangeBranchInfoHandler}>
                        <option value={0}>선택</option>
                        {varRoyaltyFList.map((flys,i)=>(
                          <option key={'flys_'+i} value={flys.ry_idx}>{flys.ry_name}</option>
                        ))}
                      </select>
                    </td>
                </tr>
                <tr>
                  <th>교실수 (마마몽떼)</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_m_classroom'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                  <th>교실수 (플라이)</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_f_classroom'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>대표자명</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_name'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                  <th>업태</th>
                  <td>
                    {Number(editMode)===0?varBranchInfo.biz_name
                    :
                      <select name='bh_biz_idx' style={{width:"200px"}} value={varBranchInfo.bh_biz_idx} onChange={onChangeBranchInfoHandler}>
                        <option value={0}>선택</option>
                        {varBusinessList.map((bizs,i)=>(
                          <option key={'bizs_'+i} value={bizs.biz_idx}>{bizs.biz_name}</option>
                        ))}
                      </select>
                    }
                  </td>
                </tr>
                <tr>
                  <th>계정</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_id'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                  <td colSpan={2}>☀︎ 초기 비밀번호는 사업자번호입니다.</td>
                </tr>
                <tr>
                  <th>사업자등록번호</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_biz_code'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                  <th>비밀번호</th>
                  <td><InputText varMode={Number(editMode)} varName={'bh_npwd'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>전화번호</th>
                  <td colSpan={3}><InputText varMode={Number(editMode)} varName={'bh_mobile'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td colSpan={3}><InputText varMode={Number(editMode)} varName={'bh_email'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
                <tr>
                  <th>우편번호</th>
                  <td colSpan={3}>
                    <span style={{width:"120px"}}>{varBranchInfo.bh_zipcode}</span>&nbsp;&nbsp;&nbsp;
                    <button onClick={e=>onOpenZipcodeHandler(e,true)} style={{width:"90px"}} className="btn line">주소찾기</button>
                  </td>
                </tr>
                <tr>
                  <th>기본주소</th>
                  <td colSpan={3}>{varBranchInfo.bh_addr1}</td>
                </tr>
                <tr>
                  <th>상세주소</th>
                  <td colSpan={3}><InputText varMode={Number(editMode)} varName={'bh_addr2'} varArrayInfo={varBranchInfo} varStyle="" onChangeHandler={onChangeBranchInfoHandler}/></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{position:"relative",width:"100%",marginTop:"10px"}}>
            <Link to={'/Admin/BranchList'} className="btn line" style={{width:"100px",position:"absolute",left:"0px"}}>목록</Link>
            <div style={{position:"absolute",right:"0px",paddingBottom:"20px"}}>
              {Number(editMode)===0?<Link to={`/Admin/BranchDetail/1/${bh_idx}`} className="btn-danger" style={{width:"100px"}}>수정</Link>:null}
              {Number(editMode)===0?<button className="btn line black" style={{width:"100px"}} onClick={e=>onModifyBranchHandler(e,2)}>삭제</button>:null}
              {Number(editMode)===0?<button className="btn line black" style={{width:"150px"}} onClick={e=>onModifyBranchHandler(e,3)}>비밀번호 초기화</button>:null}
              {Number(editMode)===1?<button className="btn-danger" style={{width:"100px"}} onClick={e=>onUpdateBranchHandler(e)}>저장</button>:null}
            </div>
          </div>
        </div>
      {/* 우편번호/주소 검색*/}
      <DaumPostCode varOpenZipcode={varOpenZipcode} ChangeAddress={ChangeAddress} ClosePopupZipcode={ClosePopupZipcode}/>
    </div>
  );
}
export  default BranchDetail;